import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';

import {
    ContextActionType,
    FlexyTabs,
    useDumbActionsContext,
} from '@europrocurement/flexy-components';

import { ArticlePanel } from './Article';
import { ArticleCategoryPanel } from './ArticleCategory';

/**
 * Dashboard "Configuration comptabilité".
 * Regroupe les onglets réservés aux administrateurs (rôle REALM_ADMIN) :
 * Articles et Catégories d'articles.
 *
 * Le chargement des données partagées est assuré par le layout parent (ConfigLayout).
 */
const AccountingConfigDashboard: React.FunctionComponent = function () {
    const contextActions: ContextActionType[] = useMemo(() => [], []);
    useDumbActionsContext(contextActions);

    const tabs = useMemo(
        () => [
            {
                tabTitle: 'Articles',
                tabPanel: <ArticlePanel />,
                tabName: 'article',
            },
            {
                tabTitle: "Catégories d'articles",
                tabPanel: <ArticleCategoryPanel />,
                tabName: 'categorieArticle',
            },
        ],
        [],
    );

    return (
        <Box>
            <Typography
                variant="h1"
                sx={{ marginBottom: 2 }}
            >
                Configuration comptabilité
            </Typography>

            <FlexyTabs
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',
                }}
                tabs={tabs}
                scrollbar={false}
            />
        </Box>
    );
};

export default AccountingConfigDashboard;
